import { ShoppingCart } from "lucide-react";

export const PURCHASE_FILTERS = [
	{
		key: "business_id",
		label: "Razón Social",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar razón social",
		options: [],
	},
	{
		key: "aptitude_id",
		label: "Aptitud",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar aptitud",
		options: [],
		multiple: true,
	},
	{
		key: "dealer_id",
		label: "Distribuidor",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar distribuidor",
		options: [],
	},
	{
		key: "season_id",
		label: "Temporada",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar temporada",
		options: [],
	},
	{ key: "date_from", label: "Fecha Ingreso Desde", type: "date", value: "", visible: true, placeholder: "Fecha ingreso desde" },
	{ key: "date_to", label: "Fecha Ingreso Hasta", type: "date", value: "", visible: true, placeholder: "Fecha ingreso hasta" },
	{ key: "date_from_document", label: "Fecha Doc. Desde", type: "date", value: "", visible: true, placeholder: "Fecha documento desde" },
	{ key: "date_to_document", label: "Fecha Doc. Hasta", type: "date", value: "", visible: true, placeholder: "Fecha documento hasta" },
];

export const PURCHASE_METADATA = {
	title: "Historial de Compras",
	subtitle: "Visualiza el historial de todas las compras realizadas",
	breadcrumb: "Compras",
	icon: ShoppingCart,
	path: "/historiales/compra",
	apiType: "purchase",
};

export const PURCHASE_BASE_TABLE = {
	page: 1,
	per_page: 100,
	order_by: "created_date",
	order_dir: "desc",
};
